// Copyright 2025. WebPros International GmbH. All rights reserved.

import {
    RouteComponentProps,
    withRouter,
} from 'react-router';
import React from 'react';
import PageHeader from 'common/components/PageHeader/PageHeader';
import { PageSection } from 'common/components/PageHeader/Styles';
import { Translate } from '@plesk/ui-library';
import DRHistoryTable from 'admin/disasterRecovery/components/HistoryTable/DisasterRecoveryHistoryTable';
import { EmptyView } from 'common/components/EmptyView/EmptyView';
import { ICONS } from 'common/constants';
import { connect } from 'react-redux';
import { track } from 'common/analytics/mixpanel';
import { ANALYTICS_EVENTS } from 'common/analytics/constants';

export interface IDisasterRecoveryHistoryProps extends RouteComponentProps {}

export const DisasterRecoveryHistory: React.FC<IDisasterRecoveryHistoryProps> = () => {

    React.useEffect(() => {
        track(ANALYTICS_EVENTS.ADMIN.DISASTER_RECOVERY.HISTORY_VISIT);
    }, []);

    return (
        <>
            <PageHeader
                title={(
                    <PageSection>
                        <Translate content="disasterRecovery.history.title" />
                    </PageSection>
                )}
            />
            <DRHistoryTable
                emptyView={<EmptyView
                    title="disasterRecovery.history.list.emptyView.title"
                    icon={ICONS.SCREEN}
                />}
            />
        </>
    );
};

export default withRouter(connect(null, null)(DisasterRecoveryHistory));
